import { RelationType } from './general.type'
import type { OrderDataMock, OrderIncluded } from './order.type'

export interface ImagingResMock<T> {
  data: T
  jsonapi: Jsonapi
  included: Included[]
  links: Links3
  meta: Meta3
}
export enum OrderStatus {
  pending = 'pending',
  completed = 'completed',
  cancelled = 'cancelled',
  in_progress = 'in_progress',
  signed = 'signed',
  scheduled = 'scheduled'
}
export interface ImagingDataMock {
  id: string
  type: 'order'
  attributes: ImagingAttributes
  links: Links
  meta: Meta
  relationships: Relationships
}

interface ImagingAttributes {
  name?: string
  ordered_at: string
  completed_at: string | null
  notes: string
  priority: string
  orderable_id: number
  orderable_type: string
  created_at: string
  updated_at: string
}

interface Links {
  self: string
  related: string
}

interface Meta {
  status: keyof typeof OrderStatus
}

interface Relationships {
  orderable: RelationType
  patient: RelationType
  ordered_by: RelationType
  encounter: RelationType
  imaging_result?: RelationType
}

interface Jsonapi {
  version: string
}

export interface Included {
  id: string
  type: string
  attributes: Attributes2
  links: Links2
  meta: never
  relationships: never
}

export type ImagingOrderData = OrderDataMock
export type ImagingOrderIncludedResource = OrderIncluded

interface Attributes2 {
  study_type: string
  category: string
  first_name: string
  last_name: string
}

interface Links2 {
  self: string
  related: string
}

interface Links3 {
  self: string
  first: string
  last: string
  prev: string | null
  next: string | null
}

interface Pagination {
  scaffold_url: string
  first_url: string
  prev_url: string
  page_url: string
  next_url: string
  last_url: string
  count: number
  page: number
  limit: number
  vars: Vars
  pages: number
  last: number
  in: number
  from: number
  to: number
  prev: any
  next: number
  series: [string, number, number, number, number, number]
}

interface Meta3 {
  pagination: Pagination
}

interface Vars {
  count_args: number
  ends: string
  limit: number
  outset: string
  page: number
  per_page: number
  start: string
  total: number
  [key: string]: any
}
